import React from 'react';
import { View, StyleSheet } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME, THEME_DARK, __WEB__ } from '../../constants/styles';

import {
  OPComponent,
  I18n,
  Utils,
  Navigation,
  NavBar,
  Container,
  SuggestionList,
} from '../components';

import { resetState, updateMedicalTeamParticipants } from '../medicalTeam/actions';
import {
  getEditingCaseParticipantsExcludingPatient,
  getEditingCaseSupervisor,
} from '../cases/selector';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import participantRoles from '../../constants/participant_roles';
import DisplayParticipant from './display_participant';

class SupervisorSelectScreen extends OPComponent {
  static options(passProps) {
    return {
      topBar: {
        rightButtons: [NavBar.buttons.save],
      },
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      selectedParticipant: props.supervisor,
    };
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    Navigation.registerForButtonEvents(this);
  }

  componentWillUnmount() {
    this.props.actions.resetState();
    this.props.callOnUnmount && this.props.callOnUnmount();
    Navigation.unRegisterForButtonEvents(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.status === 'success' && prevProps !== 'success') {
      Navigation.close(this.props);
      return;
    }
  }

  onSave = () => {
    if (!this.state.selectedParticipant?.participant) return;

    let objs = [
      {
        userId: this.state.selectedParticipant.participant.userId,
        roleId: participantRoles.SUPERVISOR,
      },
    ];

    if (this.props.supervisor?.participant?.userId) {
      objs.push({
        userId: this.props.supervisor.participant.userId,
        roleId: participantRoles.CAREGIVER,
      });
    }

    // console.info('>>> saving', objs)
    // return;

    this.props.actions.updateMedicalTeamParticipants(this.props.editingCaseId, objs);
  };

  handleResidentSelectValueChange = (val) => {};

  renderSelectedItem = () => {
    const { selectedParticipant } = this.state;
    if (!selectedParticipant) return null;

    return (
      <View style={styles.selecteContainer}>
        <DisplayParticipant participant={selectedParticipant} />
      </View>
    );
  };

  participantItems() {
    return this.props.participants.map((p) => {
      return {
        label: p.profile?.fullName,
        id: p.participant?.userId,
        participant: p,
      };
    });
  }

  handleInputChange = ({ value, item }) => {
    if (!item) return;

    this.setState({ selectedParticipant: item.participant });
  };

  renderSearchItem = (item) => {
    if (!item) return null;

    return (
      <View style={styles.listItemContainer}>
        <DisplayParticipant participant={item.participant} />
      </View>
    );
  };

  renderSearch() {
    return (
      <View style={styles.searchContainer} pointerEvents="box-none">
        <View style={styles.suggestionListContainer} pointerEvents="box-none">
          <SuggestionList
            items={this.participantItems()}
            defaultValue={null}
            onValue={this.handleInputChange}
            placeholderText={'Find Supervisor'}
            searchMode={true}
            noOverlay={true}
            autoFocus={false}
            renderItem={this.renderSearchItem}
          />
        </View>
      </View>
    );
  }

  render() {
    return (
      <Container
        errorMessage={this.props.errorMessage?.message}
        renderActivityOverlay={this.props.status === 'requesting'}
      >
        {this.renderSelectedItem()}

        <View style={{ flex: 1 }}>{this.renderSearch()}</View>
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  searchContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
  },
  suggestionListContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  selecteContainer: {
    padding: 20,
  },
  listItemContainer: {
    backgroundColor: 'white',
    padding: 20,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    casesById: state.entities.cases,
    patientsById: state.entities.patients,
    editingCaseId: state.screens.cases.caseInfoCaseId,
    status: state.screens.medicalTeam.status,
    errorMessage: state.screens.medicalTeam.errorMessage,
    participants: getEditingCaseParticipantsExcludingPatient(state),
    supervisor: getEditingCaseSupervisor(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        updateMedicalTeamParticipants,
        resetState,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SupervisorSelectScreen);
